import { Checkbox, TableCell, TableRow, Typography } from "@mui/material"
import { IFormOperatorRow } from "form/model"
import React from "react"

interface IOperatorRowProps {
  row: IFormOperatorRow
  rowIndex: number
  sspIndex: number
  isSelected: boolean
  disabled: boolean
  onSelectionChange: (row: IFormOperatorRow, checked: boolean) => any
}

export const OperatorRow = React.memo(
  ({ row, sspIndex, rowIndex, isSelected, disabled, onSelectionChange }: IOperatorRowProps) => (
    <TableRow
      sx={{
        "& > *": { borderBottom: "unset" }
      }}>
      <TableCell width="1rem">{/* padding left */}</TableCell>
      <TableCell width="1rem">
        <Checkbox
          id={`operator-list-${sspIndex}-row-${rowIndex}-select-checkbox`}
          checked={isSelected}
          disabled={disabled}
          onChange={(_event, checked) => onSelectionChange(row, checked)}
        />
      </TableCell>
      <TableCell>
        <Typography
          id={`operator-list-${sspIndex}-row-${rowIndex}-publisher-name`}
          fontSize=".8rem"
          color="textPrimary">
          {row.publisherName}
        </Typography>
      </TableCell>
      {/*
      <TableCell>
        <ColorizedText
          text={row.cpm ? row.cpm.toFixed(2) : ""}
          difference={0}
          isLoading={isLoadingOperatorsForecast}
          disabled={row.impression === 0}
          isCreationForm={isCreateForm}
        />
      </TableCell>
      <TableCell>
        <ColorizedText
          text={row.impressionRatio}
          difference={row.impressionDiff}
          isLoading={isLoadingOperatorsForecast}
          disabled={row.impression === 0}
          isCreationForm={isCreateForm}
        />
      </TableCell>
      <TableCell>
        <ColorizedText
          text={row.impressionPercent === -1 ? "-" : `${row.impressionPercent}%`}
          difference={row.impressionDiff}
          isLoading={isLoadingOperatorsForecast}
          disabled={row.impression === 0}
          isCreationForm={isCreateForm}
        />
      </TableCell>
      <TableCell>
        <ColorizedText
          text={row.screensRatio}
          difference={row.screensDiff}
          isLoading={isLoadingOperatorsForecast}
          disabled={row.screens === 0}
          isCreationForm={isCreateForm}
        />
      </TableCell>
      <TableCell>
        <ColorizedText
          text={row.screensPercent === -1 ? "-" : `${row.screensPercent}%`}
          difference={row.screensDiff}
          isLoading={isLoadingOperatorsForecast}
          disabled={row.screens === 0}
          isCreationForm={isCreateForm}
        />
      </TableCell>
      */}
      <TableCell width="1rem">{/* padding right */}</TableCell>
    </TableRow>
  )
)
